import { Text, Link } from "@chakra-ui/react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Link as ReactRouterLink } from "react-router-dom";
import { Note } from "common";
import { NoteBody } from "./NoteBody";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteAccountName } from "./useNoteAccountName";
import { useNoteYouthKid } from "./useNoteYouthKid";
import { useNoteYouthKidName } from "./useNoteYouthKidName";

interface NoteCreateYouthKidBodyProps {
  note: Note;
}

export const NoteCreateYouthKidBody = ({
  note,
}: NoteCreateYouthKidBodyProps) => {
  const account = useNoteAccount(note);
  const accountName = useNoteAccountName(note);
  const youthKid = useNoteYouthKid(note);
  const youthKidName = useNoteYouthKidName(note);

  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        created youth kid "
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/youth-kid/${youthKid?.id}`}
        >
          {youthKidName}
        </Link>
        "
      </Text>
    </NoteBody>
  );
};
